export const Required = () => <span style={{ color: '#FF0000' }}>＊</span>;
